import Util from "./util";

export default class ARUtils {

    static HOME_AR_SLOT_DATA_BASE_URL = '/home-AR-scripts/';
    static HOME_AR_SLOT_DATA_KEY = '9IZJJygKGtHUyatw5rr8Ud1EyHKvEC4161I6pz2fvYwY4SCDi6nE2oixGDMDKNghutlEKP';
    static HOME_AR_SLOT_EXPERINCE_NAME = 'peanuts';
    static HOME_AR_SLOT_EXPERINCE_ENTRYPOINT_SCRIPT_LOCATION = window.location.origin + this.HOME_AR_SLOT_DATA_BASE_URL + 'build/xr-scripts.min.js';
    static HOME_AR_EXPERINCE_CLOSING_EVENT_NAME = 'xr-session-closed';
    static AR_SLOT_ELEMENT_ID = 'ar-slot-contents';

    static REDIRECTION_LINK = 'https://www.coachoutlet.com/event/coach-x-peanuts/';


    static generateARExperienceLink(experienceURLConfig) {
        let url = '';
        if (experienceURLConfig) {
            const storeDetails = Util.getStoreDetails();
            if (storeDetails && storeDetails.countryCode) {
                url = experienceURLConfig[storeDetails.countryCode] || experienceURLConfig['USA'];
                if (url && experienceURLConfig.needStoreId) {
                    url = url.concat(`?storeId=${storeDetails.storeId}`);
                }
            }
        }

        return url;
    }
}